

import COS from "cos-js-sdk-v5"
import Axios from "axios";

export function getCOSUrl(fname){
  let bashUrl = "https://washshare-1256601262.cos.ap-guangzhou.myqcloud.com/prd/pos/";

  return bashUrl + fname;
}

let cosf = new COS({
  getAuthorization:function(options,callback){
    let url = "/customer/user/getCosTempToken?subPath=pos";

    Axios.get(url, {
      timestamp: Date.now()
    }).then((response) => {
      console.log(response.data);
      if(response.data.retcode == 0){
        let dobj = response.data.data;
        callback({
          TmpSecretId: dobj.tmpSecretId,
          TmpSecretKey: dobj.tmpSecretKey,
          SecurityToken: dobj.sessionToken,
          ExpiredTime: dobj.expiredTime,
        });}
    })
  }
});
export default cosf;

export function uploadImage(srcUrl,tarFileName,callbackFunc){
  let filebody = srcUrl
  
  cosf.putObject({
    Bucket:"washshare-1256601262",
    Region:"ap-guangzhou",
    Key:"prd/pos/"+ tarFileName,
    Body:filebody,
    onProgress:function(pd){
      console.log(JSON.stringify(pd));
    }
  },function(err, data) {
    console.log(err || data);
    if(data.statusCode == 200){     
      callbackFunc(getCOSUrl(tarFileName))
    }
  })     
}
export function getCOSThumbUrl(srcUrl,tarFileName,callbackFunc){
  let filebody = srcUrl
  
  cosf.putObject({
    Bucket:"washshare-1256601262",
    Region:"ap-guangzhou",
    Key:"prd/pos/"+ tarFileName,
    Body:filebody,
    onProgress:function(pd){
      console.log(JSON.stringify(pd));
    }
  },function(err, data) {
    console.log(err || data);
    if(data.statusCode == 200){     
      callbackFunc(getCOSUrl(tarFileName))
    }
  })     
}



// WEBPACK FOOTER //
// ./src/cos/image.js